module.exports = __webpack_public_path__ + "img/policia_estatal_up.25db03bf.svg";